module.exports = __webpack_public_path__ + "static/media/resumepdf.5c22a0ad.pdf";